import React, { useCallback, useState, useEffect } from "react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n, Trans } from "@bookingcom/lingojs-react";
import { useHistory } from "react-router-dom";
import { SearchRemoveIcon } from "@bookingcom/bui-assets-react/streamline";
import { actions as searchActions } from "../../../../store/search/actions.js";
import { useActions } from "../../../../store/index.js";
import { Button, Icon, Text, useTheme } from "@bookingcom/bui-react";
import useSearchFilters from "../../../../hooks/useSearchFilters.js";
import useCreateUrl from "../../../../hooks/useCreateUrl.js";
import Frame from "../../Frame/index.js";
import styles from "./RemoveDirectFlights.module.css";
import { useGetFiltersDraft, useSetFiltersDraft } from "./boundsFilterHooks.js";
import { useSelector } from "react-redux";
import { getFilters } from "../../../../store/search/selectors.js";
export const RemoveDirectFlights = () => {
    const theme = useTheme();
    const history = useHistory();
    const { createUrl } = useCreateUrl();
    const i18n = useI18n();
    const actions = useActions(searchActions);
    const filters = useSelector(getFilters);
    const { applyFilters } = useSearchFilters();
    const [shouldUpdate, setShouldUpdate] = useState(false);
    const filtersDraftWithBounds = useGetFiltersDraft();
    useEffect(() => {
        if (shouldUpdate) {
            applyFilters(filtersDraftWithBounds);
        }
    });
    const setFiltersDraft = useSetFiltersDraft();
    const removeDirectFlightsFilter = useCallback(() => {
        setFiltersDraft({ ...filters, stops: undefined });
        setShouldUpdate(true);
    }, [filters, setFiltersDraft]);
    return (React.createElement(Frame, { mt: 6, mb: 6, attributes: { style: { minHeight: "40vh" } } },
        React.createElement(Frame, { m: 3, alignItems: "center" },
            React.createElement(Icon, { svg: SearchRemoveIcon, size: "large", className: styles.searchRemoveIcon }),
            React.createElement(Text, { variant: "headline_3", className: styles.centerStyle }, i18n.trans(t("flights_search_no_results_header")))),
        React.createElement(Text, { variant: "body_2", className: styles.centerStyle },
            React.createElement(Trans, { tag: "flights_noresults_include_stops_message", variables: { start_link: "<0>", end_link: "</0>" }, components: [
                    React.createElement("a", { key: 0, href: "##", style: { color: theme.colors.color_action_foreground }, onClick: removeDirectFlightsFilter })
                ] })),
        React.createElement(Frame, { alignItems: "center", m: 6 },
            React.createElement(Button, { onClick: () => {
                    actions.resetFiltersButKeep({ stops: undefined });
                    history.push(createUrl("/"));
                } }, i18n.trans(t("flights_search_change_search_button"))))));
};
